<template>
    <el-select v-model="selectedData" @change="handleSelect" @visible-change="handleVisible"
               multiple
               :class="{ 'bdc-filter-select': isBdc }"
               :popper-class="isBdc ? 'bdc-filter-select-popper' : ''"
               :disabled="disabled"
               :size="size"
               :loading="loading"
               :loadingText="loadingText"
               :clearable="clearable"
               :collapseTags="collapseTags"
               :multiple-limit="multipleLimit"
               :placeholder="placeholder"
               :filterable="filterable"
               :reserve-keyword="reserveKeyword"
               :popper-append-toBody="popperAppendToBody"
               :automatic-dropdown="automaticDropdown"
               :filter-method="handleFilter"
    >

        <!-- 全选 -->
        <div class="checkbox" v-show="isCheckAll">
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选
            </el-checkbox>
        </div>

        <!-- 选项 -->
        <el-option
                v-for="(item,index) in select_optionsList"
                :key="index"
                :label="item[props.label]"
                :value="item[props.value]"
                :disabled="item[props.disabled]"
        >
            <span style="float: left">{{ item[props.label] }}</span>
            <span style="float: right; margin-left:20px; margin-right: 10px; color: #8492a6; font-size: 12px">{{ item[props.value] }}</span>
        </el-option>
    </el-select>
</template>

<script>
  import data from '../../../Sample/views/pdf/content'

  export default {
    props: {
      // 是否禁用
      disabled: {
        type: Boolean,
        default: false
      },

      // 输入框大小
      size: {
        type: String,
        default: ''
      },

      // 是否可清空
      clearable: {
        type: Boolean,
        default: false
      },

      // 是否正在从远程获取数据
      loading: {
        type: Boolean,
        default: false
      },

      // 远程加载时显示的文字
      loadingText: {
        type: String,
        default: '。。。加载中'
      },

      // 多选时是否将选中值按文字的形式展示
      collapseTags: {
        type: Boolean,
        default: false
      },

      // 多选时用户最多可以选择的项目数，为 0 则不限制
      multipleLimit: {
        type: Number,
        default: 0
      },

      // 占位符
      placeholder: {
        type: String,
        default: '请选择'
      },

      // 是否可搜索
      filterable: {
        type: Boolean,
        default: false
      },

      // 多选且可搜索时，是否在选中一个选项后保留当前的搜索关键词
      reserveKeyword: {
        type: Boolean,
        default: true
      },

      // 是否将弹出框插入至 body 元素。在弹出框的定位出现问题时，可将该属性设置为 false
      popperAppendToBody: {
        type: Boolean,
        default: true
      },

      // 对于不可搜索的 Select，是否在输入框获得焦点后自动弹出选项菜单
      automaticDropdown: {
        type: Boolean,
        default: false
      },

      // 待选项
      optionsList: {
        type: Array,
        required: true
        // default: () => []
      },

      // 选项字段
      props: {
        type: Object,
        default: () => {
          label: 'label'
          value: 'value'
          disabled:'disabled'
        }
      },

      value: {
        type: Array,
        required: true
      }
    },
    data() {
      return {
        default_optionsList: [], // 默认所有选项
        select_optionsList: [], // 待选项
        selectedValues: [], // 已选
        isIndeterminate: false, // 全选状态
        checkAll: false,
        isCheckAll: false
      }
    },

    computed: {
      isBdc() {
        return process.env.VUE_APP_PROJECT_TYPE === 'bdc'
      },

      // 已选值
      selectedData: {
        get() {
          this.selectedValues = [...this.value]
          return [...this.value]
        },
        set(val) {
          console.log('====',val)
          this.$emit('input', [...val])
        }
      }
    },

    watch: {
      optionsList(val) {
        console.log(11111, val)
        this.default_optionsList = val
        this.init()
      }
    },

    mounted() {
      // console.log('0000', this.optionsList)
      this.default_optionsList = this.optionsList
      this.init()
    },

    methods: {
      // 初始化数据
      init() {
        // console.log(2222, this.default_optionsList )
        const listAll = JSON.parse(JSON.stringify(this.default_optionsList))
        if (listAll.length > 300) {
          this.select_optionsList = listAll.slice(0, 300)
          this.isCheckAll = false
        } else {
          this.select_optionsList = listAll
          this.isCheckAll = true
        }
      },

      // 操作全选按钮
      handleCheckAllChange(val) {
        this.isIndeterminate = false
        if (val) {
          this.checkAll = val
          let values = []
          this.select_optionsList.forEach(item => {
            values.push(item[this.props.value])
          })

          this.selectedValues = values
          this.selectedData = values

        } else {
          this.selectedValues = []
          this.selectedData = []
        }

        this.handleSelect(this.selectedValues)
      },

      // 监听select值变化
      handleSelect(val) {
        // console.log('值变化====',val)
        this.selectedValues = val
        this.$emit('change', val)
        this.checkAllStatus(val) // 全选按钮显示状态标识
      },

      // 全选按钮显示状态标识
      checkAllStatus(val) {
        if (val.length == 0) { // 全不选
          this.isIndeterminate = false
          this.checkAll = false
        } else if (val.length == this.select_optionsList.length) { // 全选
          this.isIndeterminate = false
          this.checkAll = true
        } else {
          this.isIndeterminate = true
          this.checkAll = false
        }
      },

      // 监听下拉框
      handleVisible(val) {
        // console.log('监听下拉框====')
        this.$emit('visible-change', val)
        if (val) {
          this.init()

          this.checkAllStatus(this.selectedValues) // 全选按钮显示状态标识
        }
      },

      // 筛选
      handleFilter(val) {
        this.select_optionsList = []

        this.$nextTick(() => {
          const data = JSON.parse(JSON.stringify(this.default_optionsList))
          if (val) {
            this.isCheckAll = true // 显示全选按钮
            let selecteds = [] // 存储已选

            this.selectedValues.map(v => {
              selecteds.push(...(data.filter(item => item[this.props.value] == v)))
            })

            const valArr = val.toLowerCase().split(' ')
            // console.log(valArr)

            this.select_optionsList = data.filter(item => {
              let count = 0
              valArr.forEach(v => {
                if (String(item[this.props.label]).toLowerCase().indexOf(v) > -1 || String(item[this.props.value]).toLowerCase().indexOf(v) > -1) {
                  count++
                }
              })

              if (count == valArr.length) {
                return true
              } else {
                return false
              }
            })

            // console.log('最终列表111', this.select_optionsList)

            this.select_optionsList.push(...selecteds)

            this.select_optionsList = Array.from(new Set(this.select_optionsList)) // 去重

          } else {
            this.init()
          }

          this.checkAllStatus(this.selectedValues) // 全选按钮显示状态标识
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
    .checkbox {
        padding: 0 20px 0 15px;
        height: 34px;
        line-height: 34px;


        > > > .el-checkbox__label {
            font-size: 16px;
        }
    }

    > > > .el-select__tags {
        .el-tag {
            max-width: 50% !important;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }

        .el-select__input {
            margin-left: 2px;
        }
    }

    .el-select-dropdown__item {
        padding: 0 20px 0 15px;
    }

    .el-select-dropdown.is-multiple .el-select-dropdown__item.selected::after {
        right: 10px;
    }
</style>
